import React, { useMemo, useState } from "react";
import { FaSearch } from "react-icons/fa";
import blogImage1 from "../../../Assets/Homeimgs/blog1.png";
import blogImage2 from "../../../Assets/Homeimgs/blog2.png";
import blogImage3 from "../../../Assets/Homeimgs/blog3.png";
import ArticleBox from "./ArticleBox";

const blogs = [
  {
    id: 1,
    image: blogImage1,
    tag: "Web Development",
    title: "Build Modern Websites with Confidence",
    postedOn: "November 5, 2025",
    description:
      "Learn modern layouts, accessible components, and deployment workflows that ship production-ready sites.",
  },
  {
    id: 2,
    image: blogImage2,
    tag: "Career Tips",
    title: "Kickstart Your Tech Journey the Right Way",
    postedOn: "November 10, 2025",
    description:
      "Practical steps and mindset tips to grow from beginner to job-ready developer.",
  },
  {
    id: 3,
    image: blogImage3,
    tag: "Trending Tech",
    title: "Stay Ahead with the Latest Tech Trends",
    postedOn: "November 15, 2025",
    description:
      "A roundup of emerging tools, libraries, and practices to follow this year.",
  },
];

// NOTE: This file uses the same theme palette and subtle glass-like card styling as the 'MasterTheSkills' section,
// but preserves the original AllArticles layout and component structure. It intentionally borrows colors, gradients,
// and soft glows without replicating the full feature layout.

const AllArticles = () => {
  const [query, setQuery] = useState("");
  const [selectedTag, setSelectedTag] = useState("All");

  const tags = useMemo(
    () => ["All", ...Array.from(new Set(blogs.map((b) => b.tag)))],
    []
  );

  const filtered = useMemo(() => {
    const q = query?.trim().toLowerCase();

    return blogs.filter((b) => {
      const matchesTag = selectedTag === "All" || b.tag === selectedTag;
      const matchesQuery =
        !q ||
        b.title.toLowerCase().includes(q) ||
        b.tag.toLowerCase().includes(q) ||
        b.description.toLowerCase().includes(q);
      return matchesTag && matchesQuery;
    });
  }, [query, selectedTag]);

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white py-12">
      <div className="pointer-events-none absolute -top-40 -left-32 h-72 w-72 rounded-full bg-[#064585]/18 blur-3xl" />
      <div className="pointer-events-none absolute top-28 -right-36 h-80 w-80 rounded-full bg-[#5989C8]/18 blur-3xl" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl font-semibold">
              All{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
                Articles
              </span>
            </h2>
            <p className="text-sm text-slate-500 mt-1">
              {filtered.length} articles found
            </p>
          </div>

          <div className="flex items-center gap-3 w-full md:w-auto">
            <div className="relative w-full md:w-[420px]">
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search articles, tags, or excerpts..."
                className="w-full border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#5989C8] px-4 py-3 bg-white text-sm shadow-sm"
              />
              <button className="absolute right-2 top-2 text-sm px-3 text-gray-500 py-1 rounded-md">
                <FaSearch size={18} />
              </button>
            </div>

            <select
              value={selectedTag}
              onChange={(e) => setSelectedTag(e.target.value)}
              className="rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#5989C8] bg-white px-3 py-3 text-sm"
            >
              {tags.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* articles */}
        <div className="grid gap-6 md:grid-cols-3">
          {filtered.map((blog) => (
            <ArticleBox key={blog.id} blog={blog} />
          ))}

          {filtered.length === 0 && (
            <div className="col-span-full text-center py-12">
              <p className="text-slate-500">
                No articles match your search. Try different keywords.
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default AllArticles;
